import { Component, Input, Output, EventEmitter, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { IceapiService } from '../../../../../services/iceapi.service';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { JointCalcService } from 'src/app/Modules/idms/components/plant-manager/services/joint-calc-service.service';
import { CalculationType } from '../../../enums/calculation-type.enum';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-bolt-type',
    templateUrl: './bolt-type.component.html',
    styleUrls: ['./bolt-type.component.scss'],
})
export class BoltTypeComponent implements OnInit, OnDestroy {
    @Input() form: UntypedFormGroup;
    @Input() enable: boolean;
    @Input()
    set clampId(value: string) {
        this._clampId = value;
        if (!this.jointCalcService?.isPipeCode) this.getPermittedBoltTypes();
    }
    get clampId(): string {
        return this._clampId;
    }
    @Output() selected: EventEmitter<string> = new EventEmitter();
    destroy$ = new Subject();

    tooltip_position = 'above';
    loading: boolean = false;
    optionList: Map<string, string>;
    private _clampId: string;

    constructor(
        private iceapi: IceapiService,
        private cd: ChangeDetectorRef,
        private user_utility: UserUtilityService,
        private router: Router,
        private jointCalcService: JointCalcService
    ) {
        this.optionList = new Map<string, string>();
    }

    ngOnInit(): void {
        this.form.markAllAsTouched();
        if (!this.clampId && !this.jointCalcService.isPipeCode) {
            this.optionList.set('Metric', 'Metric');
            this.optionList.set('Imperial', 'Imperial');
        }
        this.form
            .get('boltType')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) {
                    if ((this.router.url == '/idms/plantmanager' || this.router.url.includes('/idms/plantmanagerView')) && this.jointCalcService.isPipeCode) {
                        this.jointCalcService.selectedBoltType.next(value);
                    }
                }
            });

        this.jointCalcService.selectedgasket.pipe(takeUntil(this.destroy$)).subscribe(async (gasket) => {
            if (gasket && this.jointCalcService?.pipeSpecpayload?.lookupParams?.calculationType == CalculationType.StandardFlange) {
                let InputGroup = this.jointCalcService.pipeSpecpayload.lookupParams;

                InputGroup.recordId.gasketId = gasket;

                InputGroup.recordId.boltMaterialId = InputGroup.others.tighteningSpecification = null;
                this.manageBolyTypedataWithPipeSpec(InputGroup);
            }
        });

        this.jointCalcService.selectedsealRingId.pipe(takeUntil(this.destroy$)).subscribe(async (sId) => {
            if (sId && this.jointCalcService?.pipeSpecpayload?.lookupParams?.calculationType == CalculationType.Clamp) {
                const inputGroup = this.jointCalcService.pipeSpecpayload.lookupParams;

                inputGroup.recordId.sealRingId = sId;
                this.manageBolyTypedataWithPipeSpec(inputGroup);
            }
        });
    }

    manageBolyTypedataWithPipeSpec(InputGroup) {
        if (this.jointCalcService.pipeSpecList.length > 1) {
            let list = this.jointCalcService.filterList(InputGroup);

            if (list.length) {
                this.optionList = new Map();

                if (list.some((x) => x.others.boltType == 0)) this.optionList.set('Metric', 'Metric');

                if (list.some((x) => x.others.boltType == 1)) this.optionList.set('Imperial', 'Imperial');
            }

            else {
                 this.optionList = new Map();
                   if (this.jointCalcService.pipeSpecList.some((x) => x.others.boltType == 0)) this.optionList.set('Metric', 'Metric');

                   if (this.jointCalcService.pipeSpecList.some((x) => x.others.boltType == 1)) this.optionList.set('Imperial', 'Imperial');

                  }
        } else if (this.jointCalcService.pipeSpecList.length == 1) {
            this.optionList = new Map();
            if (this.jointCalcService.pipeSpecList[0].others.boltType == 0) this.optionList.set('Metric', 'Metric');
            if (this.jointCalcService.pipeSpecList[0].others.boltType == 1) this.optionList.set('Imperial', 'Imperial');
        }
        if (this.optionList.size == 1) {
            this.form.get('boltType').setValue(this.optionList.values().next().value);
        }
    }

    getPermittedBoltTypes(): void {
        this.form.markAllAsTouched();
        if (!this.clampId) return;
        this.loading = true;

        this.optionList?.clear();

        this.iceapi
            .getClamp(this.clampId)
            .pipe(takeUntil(this.destroy$))
            .subscribe((clamp) => {
                if (clamp.success === true) {
                    this.iceapi
                        .getBoltTypes(clamp.response.boltMinDiameter.metric.value, clamp.response.boltMaxDiameter.metric.value)
                        .subscribe((boltTypes) => {
                            if (boltTypes.success === true) {
                                this.loading = false;
                                this.cd.markForCheck();
                                if (boltTypes.response.some((x) => x == 0)) this.optionList.set('Metric', 'Metric');
                                if (boltTypes.response.some((x) => x == 1)) this.optionList.set('Imperial', 'Imperial');

                                if (this.optionList.size === 1) this.form.get('boltType').setValue(this.optionList.values().next().value);
                                if (this.form.get('boltType').value !== '') {
                                    this.form.get('boltType').setValue(this.form.get('boltType').value), this.cd.markForCheck();
                                }
                            } else {
                                this.loading = false;
                                this.cd.markForCheck();
                                this.user_utility.errorModelPopup(boltTypes.message);
                            }
                        });
                } else {
                    this.loading = false;
                    this.cd.markForCheck();
                    this.user_utility.errorModelPopup(clamp.message);
                }
            });
    }

    selectBoltType(selectedValue: MatSelectChange): void {
        const selection = this.optionList.get(selectedValue.value);
        if (selection) {
            this.selected.emit(selection);
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
